const giftContainer = () => {
    const giftContainer = document.querySelector(".rebuy-cart__notes");
    giftContainer.innerHTML = `<span class="gifting-message"><img src="https://cdn.shopify.com/s/files/1/0447/4049/files/Captura_de_pantalla_2025-05-02_a_la_s_1.02.36_p._m..png?v=1746208963"/> Gifting? Add a Gift Box & Personal Note</span>`;
    document.querySelector(".gifting-message").addEventListener("click", () => {
        document.querySelector(".rebuy-cart__flyout-close").click();
        document.getElementById('giftModal').removeAttribute("style");
        document.querySelector(".modal-wrapper").classList.add("open");
        document.querySelector(".modal-overlay").classList.add("open");
    });
}

const freeShipping = (cart) => {
    const subtotalContainer = document.querySelector(".rebuy-cart__flyout-subtotal-label");
    const subtotalPriceContainer = document.querySelector(".rebuy-cart__flyout-subtotal-amount");

    const existingText = document.querySelector(".free-shipping-text");
    const existingValue = document.querySelector(".free-shipping-value");
    if (cart.total_price > 7500) {
        if (!existingText && !existingValue) {
            subtotalContainer.insertAdjacentHTML("beforeend", `<span class="free-shipping-text">SHIPPING</span>`);
            subtotalPriceContainer.insertAdjacentHTML("afterbegin", `<span class="free-shipping-value">FREE!</span>`);
        }
    } else {
        if (existingText) existingText.remove();
        if (existingValue) existingValue.remove();
    }
}

document.addEventListener('rebuy:smartcart.ready', (event) => {
    setTimeout(() => {
        giftContainer();
        document.querySelector("[data-rebuy-component=checkout-area]").insertAdjacentHTML(
            "afterend", 
            `<img width="100%" src="https://cdn.shopify.com/s/files/1/0447/4049/files/Express_Payment.png?v=1746209534" />`
        );
    }, 1000);

})
document.addEventListener('rebuy:cart.change', (event) => {
    setTimeout(() => {
        giftContainer();
        freeShipping(event.detail.cart.cart);
    }, 700); 
});